import React from 'react';
import { WizardContent } from 'site-modules/shared/components/inventory/incentives-wizard/wizard-content/wizard-content';
import { PersistedStateIncentivesWizard } from 'site-modules/shared/components/incentives/incentives-wizard/persisted-state-incentives-wizard';

export const PersistedStateWizardContent = props => (
  <WizardContent {...props} wizardComponent={PersistedStateIncentivesWizard} />
);
